export default __webpack_public_path__ + "static/media/check-mark.7fd05088.svg";